export default __webpack_public_path__ + "static/media/botenlift_mast.c4eb6e42.svg";